export default __webpack_public_path__ + "static/media/Chevron_Up.8af45f85.svg";